import * as React from "react";
import { ILawyer } from "src/services/interfaces/ILawyer";

export const LawyerInfo = (props: { lawyer: ILawyer }) => (
  <div className="region-container lawyer-info">
    <span className="subtitle">Dados do Advogado</span>
    <div>
      <div className="row">
        <span className="left description">Nome:</span>
        <span className="right description">{props.lawyer.fullName}</span>
      </div>
      <div className="row">
        <span className="left description">Documento:</span>
        <span className="right description">{props.lawyer.cpf}</span>
      </div>
      <div className="row">
        <span className="left description">OAB:</span>
        <span className="right description">
          {props.lawyer.oab}/{props.lawyer.oabState}
        </span>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/LawyerInfo/LawyerInfo.tsx